<template>
  <span class="residential-badge" :class="view.cls" :title="view.hint">
    <i class="mdi" :class="view.icon"></i>
    {{ view.label }}
  </span>
</template>

<script>
// Residencial o comercial de una dirección guardada. Lo detecta ShipStation
// con la calle al guardarla (address_verified = 1); residencial lleva recargo
// del carrier en las tarifas.
const isOn = value => value === true || value === 1 || value === "1";

export default {
  name: "ResidentialBadge",
  props: {
    residential: {
      type: [String, Number, Boolean],
      default: null
    },
    verified: {
      type: [String, Number, Boolean],
      default: null
    },
    // El del calculador (no_street, not_found...): sin calle el aviso es otro
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    view() {
      const t = key => this.$t(`shipping_calculator.${key}`);
      if (this.residential === null || this.residential === "") {
        return {
          cls: "is-pending",
          icon: "mdi-home-search-outline",
          label: t("residential_pending"),
          hint: t("residential_pending_hint")
        };
      }
      const verified = isOn(this.verified);
      if (isOn(this.residential)) {
        return verified
          ? {
              cls: "is-residential",
              icon: "mdi-home",
              label: t("residential"),
              hint: t(
                this.status === "unclassified"
                  ? "residential_unclassified_hint"
                  : "residential_hint"
              )
            }
          : {
              cls: "is-assumed",
              icon: "mdi-home-alert-outline",
              label: t("residential_assumed"),
              hint: t(
                this.status === "no_street"
                  ? "residential_no_street_hint"
                  : "residential_unverified_hint"
              )
            };
      }
      return verified
        ? {
            cls: "is-commercial",
            icon: "mdi-office-building-outline",
            label: t("commercial"),
            hint: t("commercial_hint")
          }
        : {
            cls: "is-pending",
            icon: "mdi-office-building-outline",
            label: t("commercial_unverified"),
            hint: t("commercial_unverified_hint")
          };
    }
  }
};
</script>

<style lang="postcss" scoped>
.residential-badge {
  @apply inline-flex items-center gap-1 rounded px-2 py-1 text-sm font-semibold;
}
.residential-badge.is-pending {
  @apply bg-gray-100 text-gray-600;
}
.residential-badge.is-commercial {
  @apply bg-blue-100 text-blue-800;
}
.residential-badge.is-residential {
  @apply bg-yellow-100 text-yellow-800;
}
.residential-badge.is-assumed {
  @apply bg-red-100 text-red-800;
}
</style>
